<div class="excel-column-mapper">
    @for (field of fields; track field.key) {
        <div class="row mb-2 align-items-center">
            <label class="col-24 col-md-6 form-label mb-md-0">
                {{ field.label }}
                @if (field.required) {
                    <span class="text-danger" title="Verplicht veld">*</span>
                }
                @if (field.description) {
                    <small class="d-block text-muted">{{ field.description }}</small>
                }
            </label>
            <div class="col-24 col-md-18">
                @let conflict = getConflictingField(field);
                <ng-select
                    class="column-select"
                    [items]="columns"
                    placeholder="Geen koppeling"
                    [clearable]="true"
                    appendTo="body"
                    [class.is-invalid]="(field.required && !fieldColumns[field.key]) || conflict"
                    [ngModel]="fieldColumns[field.key]"
                    (ngModelChange)="onColumnSelected(field, $event)">
                    <ng-template ng-label-tmp let-column="item">
                        <b>{{ column }}</b>
                        <small class="text-muted ms-1">{{ column | columnValueInfo: rows }}</small>
                    </ng-template>
                    <ng-template ng-option-tmp let-column="item">
                        <b>{{ column }}</b>
                        <small class="text-muted ms-1">{{ column | columnValueInfo: rows }}</small>
                        @let usedBy = getFieldUsingColumn(column, field);
                        @if (usedBy) {
                            <small class="d-block text-muted">Wordt gebruikt als {{ usedBy.label }}</small>
                        }
                    </ng-template>
                </ng-select>
                @if (field.required && !fieldColumns[field.key]) {
                    <small class="text-danger d-block">Dit verplichte veld is nog niet gekoppeld.</small>
                }
                @if (conflict) {
                    <small class="text-danger d-block"
                        >Deze kolom is ook gekoppeld aan "{{ conflict.label }}" - kies voor één van beide een andere
                        kolom.</small
                    >
                }
            </div>
        </div>

        @if (field.valueOptions?.length && fieldUniqueValues[field.key]?.length) {
            <div class="ps-md-4 mb-3">
                <p class="text-muted small mb-1">
                    Waardekoppeling voor <em>{{ field.label }}</em
                    >:
                </p>
                @for (rawValue of fieldUniqueValues[field.key]; track rawValue) {
                    <div class="row mb-1 align-items-center">
                        <label class="col-24 col-md-6 small fst-italic mb-md-0">{{ rawValue }}</label>
                        <div class="col-24 col-md-18">
                            <ng-select
                                [items]="field.valueOptions"
                                placeholder="Niet koppelen"
                                [clearable]="true"
                                [ngModel]="fieldValueMaps[field.key]?.[rawValue] ?? null"
                                (ngModelChange)="onValueMapped(field.key, rawValue, $event)">
                            </ng-select>
                        </div>
                    </div>
                }
            </div>
        }
    }
</div>
